var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.3335,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E0E2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.3335,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#F0F1F3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 15C14.3335 15 13.3335 18 13.3335 20.5C13.3335 23.5 15.3335 28 17.3335 28C18.4215 27.954 19.0125 27.5 20.3335 27.5C21.6455 27.5 21.8335 28 23.3335 28C24.8335 28 27.3335 25 27.3335 23C27.3055 22.99 24.8615 22.597 24.8335 20C24.8145 17.83 27.2495 17.046 27.3335 17C26.3105 15.508 24.3825 15.037 23.8335 15C22.4005 14.889 21.0035 16 20.3335 16C19.6535 16 18.4335 15 17.3335 15Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3335 12C20.8639 12 21.3726 11.7893 21.7477 11.4142C22.1228 11.0391 22.3335 10.5304 22.3335 10C21.8031 10 21.2944 10.2107 20.9193 10.5858C20.5442 10.9609 20.3335 11.4696 20.3335 12Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosReferrals);
export default __webpack_public_path__ + "static/media/iosReferrals.cad6d414772d4b7a7861f6e79338ee7f.svg";
export { ForwardRef as ReactComponent };